import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import { websites } from '../../../../redux/websites/action';
import { selectWebsiteListItems } from '../../../../redux/websites/selector';
import { pages } from '../../../../redux/pages/action';
import { selectPageQueryItems } from '../../../../redux/pages/selector';
import PageComponent from '../components/page.component';
import { format } from '../../../../common/services/date.service';
import { formatWebsiteListData } from '../../../../common/services/common.service';
import PageLoader from '../../../../components/PageLoader';
import storePersist from '../../../../redux/storePersist';
import { layouts } from '../../../../redux/layouts/action';
import { selectLayoutListItems } from '../../../../redux/layouts/selector';
import { selectnetworksListItems } from '../../../../redux/networks/selector';
import { networks } from '../../../../redux/networks/action';
import * as R from "ramda"

const Page= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const websitesLists = useSelector(selectWebsiteListItems)
  const routeQuery = useSelector(selectPageQueryItems)
  const layoutList = useSelector(selectLayoutListItems)
  const [isLoading, setIsLoading] = useState<boolean>(true) 
  const networkItems = useSelector(selectnetworksListItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
var tenantId = storePersist?.get("tokenData")?.current?.result?.TokenMetadata?.TenantId;
const [pageData, setPageData] = useState(1)
  const [
    selectedPage,
    setSelectedPage
  ] = useState<any>([])
  const [
    layout,
    setLayouts
  ] = useState<any>([])
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer (params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Message.LayoutName', headerName: 'Layout Name', sortable: true, filter: true },
      { field: 'Message.PageName', headerName: 'Page Name' },
      { field: 'Message.LayoutVersionId', headerName: 'Layout Version' },
    ]);
  }

  const fetchPageById= ()=>{
    dispatch(pages.query({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-pages/query`,entity:'pages',jsonData:{
          
    Records: [
      {
        
          "context": {},
          "message": {
              "Id": parmas?.id,
              "TenantId": tenantId
          }
      
       
      }
    ]
  }})).then(()=>{
    
  setIsQuery(true)


  }
)
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedPage({ ...selectedPage, [field]: event });
  }

  const handleFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedPage({ ...selectedPage, [fields[0]]: value });
  }
  useEffect(
    () => {
      
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-websites/list`,
        entity: 'websites',
        jsonData: {}
    })).then(()=>{
      dispatch(networks.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/networks/list`,entity:'endpoints',jsonData:{}}))
        }).then(()=>{
      dispatch(layouts.list({ url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layouts/list`,
        entity: 'layouts',jsonData:{"Filters": [
              {
                "FieldName": "PlatformWebSitePageId",
                "FilterOperatorId": 1,
                "FieldValue": parmas?.id,
                "FieldType": "number"
              }
            ],
            "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",}}))
      }).then(()=>{
      if (parmas?.id > 0) {
        fetchPageById()
        createColumnDefs()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }
})},
    [pageData]
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedPage(routeQuery?.result?.items)
        setLayouts(layoutList?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    const updatedSelectedPages = { ...selectedPage, TenantId: tenantId };
    if (parmas?.id > 0) {
      await dispatch(pages.resetAction({ actionType: 'update' }))
     await dispatch(pages.update({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-pages`,entity:'pages',jsonData:{
          
    Records: [
      {
        
        "context": {},
        "message": updatedSelectedPages
        
    
     
    }
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(pages.resetAction({ actionType: 'create' }))
      await dispatch(pages.create({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-pages`,entity:'pages',jsonData:{
          
      Records: [
        {
        
          "context": {},
          "message": updatedSelectedPages
    
      
       
      }
      ]
    
  }})).then(()=>{
    back()
  })
    }
   
  }

const back=()=>{
  navigate('/web-platform/pages')
} 

const handleAdd=()=>{
  navigate(`platform-website-layout/${0}`)
}
const handleEdit=(data: any)=>{
  navigate(`platform-website-layout/${data?.Message?.Id}`)
 }
 
const additionButtons: any = [
  {
    name: 'Add Layouts',
    callback: () => handleAdd(),
  }
];
    return (
    <>
       {isLoading ? <PageLoader /> : 
          <PageComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedRoute={selectedPage}
           websites={formatWebsiteListData(websitesLists?.result?.items)}
           back={back}
           handleFormSubmit={handleFormSubmit}
           id={parmas?.id}
           columnDefs={columnDefs}
           onEdit={handleEdit}
           layout ={layout}
           additionButtons={additionButtons}
           paginationData={layoutList?.result?.pagination}
           setPageData={setPageData}
           networks={networkItems?.result?.items}
           handleFormChange={handleFormChange}
          />  
    }
          </>
    )
    
    }
   
    export default Page;